export default {
    LOAD_STORE_GIFT_LIST_ITEMS (state, storegiftlistitem) {
        state.items = storegiftlistitem
    }
}